import { getRequest } from '@/core';
import { orderTypes } from '@/requests';

export default async function getOrderTypesRequest() {
	let url = orderTypes.getPath();
	try {
		let response = await getRequest(url);
		return response;
	} catch (err) {
		if (err.response && err.response.data) {
			throw new Error(err.response.data);
		}
		throw err;
	}
}